export const encodeEntity = (topic: string) => {
  // encodeURIComponent doesn't handle periods or apostrophes
  return encodeURIComponent(topic).replaceAll('.', '%2E').replaceAll("'", '%27');
};

export const capitalize = (str: string) => {
  return str?.replace(/#/, '').replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};
